import styled from "styled-components";

export const LogoWrap = styled.div`
  width: 9rem;
  height: 9rem;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ theme, small }) => theme.palette.common.background};
  position: relative;

  img {
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    align-self: center;
  }
`;
